import TabContent from "./TabContent";
import styled from "styled-components";
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Paper, Box } from "@mui/material";
import { getLayerCollectionDetail } from '@/utils/helpers';

const Wrapper = styled(Paper)`
  &.MuiPaper-root {
    background-color: #2f2f2f;
  }
`;

const CustomTabs = styled(Tabs)`
  .MuiTabs-flexContainer {
    align-items: center;
    justify-content: space-evenly;
  }
  .MuiTabs-indicator {
    background-color: #287bf2;
  }
`;

const CustomTab = styled(Tab)`
  &.MuiTab-root {
    color: #a0a0a0;
    font-size: 15px;
    font-weight: 700;
    font-family: "Roboto", sans-serif;
    line-height: 19px;
    text-transform: none;
    min-width: unset;
    padding: 0;
    &.Mui-selected {
      color: #ffffff;
    }
    &:focus {
      outline: none;
    }
  }
`;

const a11yProps = (index) => {
  return {
    id: `metadata-tab-${index}`,
    "aria-controls": `metadata-tabpanel-${index}`,
  };
};

const Content = (props) => {
  const { info, _ } = props;
  const [tabInfo, setTabInfo] = useState();
  const maxNumberOfTilesInEachDirection = 3;
  const [tabValue, setTabValue] = useState();
  const [collections, setCollections] = useState();
  const selectedMission = useSelector(state => state.asset.selectedMission?.split(':')[1]);

  const sortCollections = (collections) => {
    if (!collections) return collections;

    var collectionsArray = Object.entries(collections);
    var sortedCollectionsArray = collectionsArray.sort(([collection_1,], [collection_2,]) => {
      collection_1 = getLayerCollectionDetail(collection_1);
      collection_2 = getLayerCollectionDetail(collection_2);
      return collection_1[1].cardinal_direction - collection_2[1].cardinal_direction
    });
    var sortedCollections = Object.fromEntries(sortedCollectionsArray);

    return sortedCollections;
  }
  
    const handleChange = (event, newValue) => {
      setTabValue(newValue);
    };

  useEffect(() => {
    let sortedCollections = sortCollections(info);
    setCollections(sortedCollections);
  }, [info]);

  useEffect(() => {
    if (collections === undefined || Object.keys(collections).length === 0) {
      setTabValue();
      return;
    }
    
    if (tabValue === undefined || tabValue === 0) {
      setTabValue(undefined);
      setTimeout(() => {setTabValue(0)}, 0);
    }
  }, [collections]);

  useEffect(() => {
    if (tabValue === undefined || !(selectedMission in collections[Object.keys(collections)[tabValue]])) {
      setTabInfo({});
      return;
    };
    
    setTabInfo(Object.fromEntries(Object.entries(collections[Object.keys(collections)[tabValue]][selectedMission]).slice(0, maxNumberOfTilesInEachDirection)));
  }, [tabValue]);

  return (
    <>
      {collections &&
        <Wrapper square>
          <Box px="25px" pt="26px" pb="12px" width="100%">
            <CustomTabs
              value={tabValue}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary">
              {
                Object.keys(collections).map((item, index) => (
                  <CustomTab label={item} {...a11yProps(index)} key={item} />
                ))
              }
            </CustomTabs>
          </Box>
          <Box>
            {tabInfo && <TabContent tabInfo={tabInfo} tabValue={Object.keys(collections)[tabValue]} />}
          </Box>
        </Wrapper>}
    </>
  );
};

export default Content;